export default __webpack_public_path__ + "static/media/IMG_0706 copie.0f46f074.jpg";